import { BaseModel } from './BaseModel';

export class Setting extends BaseModel {
  static get entity() {
    return 'settings';
  }

  static fields() {
    return {
      id: this.uid(),
      key: this.attr(null),
      value: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      /**
       * Get the list of popular search keywords.
       * @returns {Promise} - A promise that resolves to the list of popular search keywords.
       */
      fetchPopularSearches() {
        return this.get('/settings/popular-searches', { save: false });
      }
    }
  };
}

export default Setting;
